@use '@/styles/variables' as *;

.wrapper {
  position: relative;
  margin: 0.75rem 0;

  &:hover .copyBtn {
    opacity: 1;
  }
}

.lang {
  position: absolute;
  top: 0.65rem;
  left: 1.25rem;
  font-family: var(--font-mono, 'Fira Code', 'Cascadia Code', monospace);
  font-size: 0.7rem;
  color: color-mix(in oklch, var(--muted-foreground) 55%, transparent);
  text-transform: lowercase;
  letter-spacing: 0.04em;
  user-select: none;
}

.copyBtn {
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: color-mix(in oklch, var(--muted) 80%, var(--background));
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.25rem 0.55rem;
  color: var(--muted-foreground);
  font: inherit;
  font-size: 0.75rem;
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover:not(:disabled) {
    color: var(--foreground);
    border-color: var(--foreground);
  }

  &:focus-visible {
    opacity: 1;
    outline: 2px solid var(--foreground);
    outline-offset: 2px;
  }
}

.copyBtnCopied {
  color: var(--forest);
  border-color: var(--forest);
  opacity: 1;
}

.pre {
  font-family: var(--font-mono, 'Fira Code', 'Cascadia Code', monospace);
  font-size: 0.875rem;
  background: color-mix(in oklch, var(--muted) 60%, var(--background));
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 1.25rem 0;
  overflow-x: auto;
  line-height: 1.7;
  white-space: pre;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in oklch, var(--muted-foreground) 40%, transparent) transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 0 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: color-mix(in oklch, var(--muted-foreground) 40%, transparent);
    border-radius: 3px;

    &:hover {
      background: color-mix(in oklch, var(--muted-foreground) 65%, transparent);
    }
  }

  code {
    display: block;
  }
}

.line {
  display: flex;
  padding: 0 1.5rem 0 0;
}

.lineNum {
  flex-shrink: 0;
  width: 2.5rem;
  padding: 0 1rem 0 1.25rem;
  color: color-mix(in oklch, var(--muted-foreground) 50%, transparent);
  text-align: right;
  user-select: none;
}

.lineContent {
  flex: 1;
  color: var(--muted-foreground);
}

@media (prefers-reduced-motion: reduce) {
  .copyBtn {
    transition: none;
  }
}
